// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3dGdk","boxTitle":"Qualiphy_boxTitle__3z-p5","box":"Qualiphy_box__27cbS","toggleWrap":"Qualiphy_toggleWrap__XwX7w"};